import {
  EPersonaIntegrationMode,
  IPersonaEmbedSettings,
  tavusPersonaStore
} from 'entities/tavus/persona';
import avatar from './exmaple-avatar.jpg';
import { useAuthStore } from 'stores/useAuthStore';

const PictureInPuctureCamera = ({
  windowFields
}: {
  windowFields: IPersonaEmbedSettings;
}) => {
  const { personaIntegrationViewMode } = tavusPersonaStore();

  return (
    <>
      {windowFields.camera && (
        <div
          className={`ag-absolute ag-border ag-backdrop-blur-[21.5px] ag-flex ag-flex-col ag-justify-center ag-duration-200 ag-transition-all ag-items-center ${
            personaIntegrationViewMode === EPersonaIntegrationMode.EMBED
              ? 'ag-top-3 ag-left-3 ag-right-auto ag-bottom-auto xl:ag-right-3 xl:ag-bottom-3 xl:ag-top-auto xl:ag-left-auto'
              : 'ag-top-3 ag-left-3'
          } ag-rounded-xl ag-w-[168px] ag-h-[94px] max-w-md mx-auto aspect-video rounded-2xl overflow-hidden border border-white`}
        >
          <div className="af-flex ag-flex-col ag-justify-center ag-items-center ag-relative ag-group">
            <div className="ag-hidden lg:ag-flex lg:ag-absolute ag-pointer-events-none ag-text-vivid-purple -ag-bottom-7 ag-ml-2 ag-opacity-0 group-hover:ag-opacity-100 ag-transition-opacity ag-text-xs ag-z-10">
              <span className="ag-bg-white ag-px-3 ag-py-1.5 ag-shadow ag-whitespace-nowrap ag-rounded">
                You
              </span>
            </div>
            <div className="ag-flex ag-flex-col ag-justify-center ag-items-center ag-w-[56px] ag-h-[56px] ag-overflow-hidden ag-rounded-full ag-border ag-relative">
              <img
                src={avatar}
                alt="Avatar"
                className="ag-w-[56px] ag-pointer-events-none ag-select-none ag-h-[56px] ag-object-cover"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PictureInPuctureCamera;
